import type { CategoryContent } from '../row.js';

/** Nederlands & internationaal IE-recht. */

export const LAWIP: CategoryContent = {
  bscba: [
    [
      'Is registratie in de meeste auteursrechtstelsels ter wereld vereist om voor een werk auteursrechtelijke bescherming te verkrijgen?',
      [
        'Nee, auteursrecht ontstaat automatisch bij creatie in vrijwel alle landen die partij zijn bij grote internationale auteursrechtverdragen',
        'Ja, elk land vereist registratie bij een nationaal auteursrechtenbureau voordat bescherming begint',
        'Alleen in de Verenigde Staten en Japan',
        'Alleen als het werk in gedrukte vorm wordt gepubliceerd',
      ],
      0,
      'De Berner Conventie bepaalde dat auteursrecht automatisch ontstaat—geen registratie, melding of andere formaliteit is vereist. De meeste landen volgen dit principe, hoewel sommige landen optionele nationale registers voor bewijsdoeleinden bijhouden.',
    ],
    [
      'Wat is het primaire juridische doel van een handelsmerk?',
      [
        'De bron of herkomst van goederen of diensten identificeren en deze onderscheiden van andere',
        'Voorkomen dat enig ander bedrijf vergelijkbare woorden of symbolen gebruikt',
        'De auteursrechtbescherming van een merknaam voor onbeperkte duur uitbreiden',
        'Exclusief recht geven om een bepaald woord in elke context te gebruiken',
      ],
      0,
      'De kernfunctie van een merk is dienen als herkomstherkenning: het helpt consumenten goederen of diensten van een bepaalde bron te herkennen. Deze herkomstfunctie is wat de meeste merkenwetten beschermen.',
    ],
    [
      'Welk van de volgende wordt NIET typisch beschouwd als patenteerbare werkingsfeer?',
      [
        'Een natuurlijk voorkomende genensequentie die zonder wijziging uit het menselijk lichaam is geëxtraheerd',
        'Een nieuwe chemische verbinding die synthetisch in een laboratorium is samengesteld',
        'Een nieuw fabricageproces voor het produceren van halfgeleiders',
        'Een nuttig apparaat dat bestaande onderdelen op innovatieve wijze combineert',
      ],
      0,
      'Natuurproducten, natuurwetten en abstracte ideeën zijn in de meeste rechtsgebieden over het algemeen niet patenteerbaar. Een genetisch gemodificeerd organisme of gezuiverde natuurstof met nieuwe eigenschappen kan echter patenteerbaar zijn.',
    ],
    [
      'Wat betekent "first-to-file" in octrooirecht?',
      [
        'De persoon die eerst een octrooiaanvraag indient heeft prioriteit, ongeacht wie het daadwerkelijk heeft uitgevonden',
        'Alleen de oorspronkelijke uitvinder mag een octrooiaanvraag indienen',
        'Octrooirechten behoren toe aan wie het eerst over de uitvinding publiceert in een vakblad',
        'Uitvinders moeten hun ontdekking publiceren voordat zij een aanvraag indienen, om zo prioriteit vast te stellen',
      ],
      0,
      'De meeste landen wereldwijd, waaronder de EU en vele andere, gebruiken een first-to-file-systeem waarbij de vroegste aanvraagdatum prioriteit bepaalt. De VS gebruikte historisch first-to-invent tot 2013.',
    ],
    [
      'Hoe lang beschermt een standaard octrooiverlening een uitvinding?',
      [
        '20 jaar vanaf de indiendatum van de aanvraag',
        '17 jaar vanaf de datum waarop het octrooi wordt verleend',
        'Het leven van de uitvinder plus 50 jaar',
        'Onbeperkt, zolang de octrooihouder jaarlijkse vernieuwingskosten betaalt',
      ],
      0,
      'De standaard octrooitermijn in de meeste landen is 20 jaar vanaf de indiendatum. De uitvinding zelf wordt echter openbaar bij indiening, en de werkelijke beschermingsperiode kan worden verkort als het octrooi jaren onderzoek vergt.',
    ],
    [
      'Wat is een bedrijfsgeheim?',
      [
        'Informatie die waarde ontleent aan het feit dat ze niet algemeen bekend is, en die door redelijke maatregelen geheim wordt gehouden',
        'Een octrooi dat nog niet door het octrooibureau is gepubliceerd',
        'Een merk dat vertrouwelijk is en niet openbaar wordt gemaakt',
        'Een kopie van de financiële administratie van een bedrijf in een kluis',
      ],
      0,
      'Bedrijfsgeheimen beschermen informatie door geheimhouding en redelijke beschermingsmaatregelen, niet door registratie. Zij vereisen geen formele procedures maar bieden bescherming alleen zolang informatie vertrouwelijk blijft.',
    ],
    [
      'Welk internationaal verdrag bepaalde dat auteursrechtbescherming geen registratie of melding vereist?',
      [
        'De Berner Conventie voor de Bescherming van Werken van Letterkunde en Kunst',
        'Het Verdrag van Parijs voor de Bescherming van de Industriële Eigendom',
        'Het TRIPS-akkoord',
        'Het Oprichtingsverdrag van de Wereldorganisatie voor de Intellectuele Eigendom',
      ],
      0,
      'De Berner Conventie (1886) stelde in artikel 5(2) vast dat auteursrechtbescherming automatisch is en niet afhangt van enige formaliteit zoals registratie, melding of indiening. TRIPS en WIPO-verdragen hebben dit principe later overgenomen.',
    ],
    [
      'Waarvoor wordt het Madridprotocol vooral gebruikt?',
      [
        'Merkaanvragen indienen in meerdere landen via één WIPO-procedure',
        'Merkenwetten harmoniseren in de EU-lidstaten',
        'Octrooien wereldwijd afdwingen',
        'Geografische aanduidingen voor landbouwproducten registreren',
      ],
      0,
      'Het Madridprotocol, beheerd door WIPO, centraliseert merkaanvragen via één aanvraag voor meerdere aangewezen landen. Het bureau van elk land onderzoekt het merk echter nog steeds naar zijn eigen materiële recht.',
    ],
    [
      'Wat is de basisvereiste voor auteursrechtbescherming van een literair of kunstwerk?',
      [
        'Het werk moet oorspronkelijk zijn en in een tastbaar medium worden uitgedrukt (geschreven, opgenomen, enz.)',
        'Het werk moet commercieel worden gepubliceerd',
        'Het werk moet bij een nationaal auteursrechtenbureau worden geregistreerd',
        'Het werk moet minstens 100 pagina\'s lang zijn of één uur duren',
      ],
      0,
      'Auteursrecht beschermt oorspronkelijke literaire en kunstwerken zodra zij in een tastbaar medium worden vastgelegd—zoals schrijven, opnamen of digitale opslag. Oorspronkelijkheid en vastlegging zijn de belangrijkste vereisten.',
    ],
    [
      'Wat verleent het Europees Octrooibureau (EOB)?',
      [
        'Een bundel nationale octrooien in aangewezen landen, die afzonderlijk in elk land moeten worden gevalideerd en afgedwongen',
        'Een enkel Europees octrooi dat automatisch geldig en afdwingbaar is in alle EU-lidstaten',
        'Alleen gebruiksoctrooien, terwijl modelrechten uitsluitend door WIPO worden afgehandeld',
        'Een voorlopig octrooirecht dat volledige bescherming krijgt na EU-goedkeuring',
      ],
      0,
      'Een Europees octrooi verleend door het EOB is eigenlijk een bundel die in elk aangewezen land moet worden gevalideerd en kan in elk land afzonderlijk worden afgedwongen of ingetrokken.',
    ],
    [
      'Welk van de volgende beschrijft het best de bijdrage van het Verdrag van Parijs aan internationaal octrooi- en merkenrecht?',
      [
        'Het stelde het "prioriteitsrecht" in dat aanvragers toestaat in meerdere landen aan te vragen terwijl zij hun eerste indiendatum behouden',
        'Het schafte octrooien in ontwikkelingslanden af',
        'Het creëerde WIPO als handhavingsinstantie',
        'Het verenigde octrooiexaminatieprocedures in alle aangesloten landen',
      ],
      0,
      'Het Verdrag van Parijs (1883) voerde het prioriteitsrecht in: aanvragers kunnen in één lid aanvragen en dan in andere leden binnen 12 maanden voor octrooien of 6 maanden voor merken, terwijl zij de oorspronkelijke indiendatum als prioriteit behouden.',
    ],
    [
      'Wat onderscheidt een moraal recht van een economisch recht in auteursrecht?',
      [
        'Morele rechten beschermen de persoonlijke band van de auteur met een werk (naamsvermelding, integriteit) en zijn over het algemeen onvervreemdbaar',
        'Morele rechten duren slechts één jaar terwijl economische rechten duren voor de auteursrechttermijn',
        'Economische rechten gelden alleen voor boeken; morele rechten gelden alleen voor visuele kunst',
        'Morele rechten bestaan alleen in Engelssprekende landen',
      ],
      0,
      'Morele rechten—het recht op naamsvermelding en het recht tegen vervormingen—beschermen de reputatie en persoonlijke band van de auteur. Ze kunnen niet worden verkocht of overgedragen, zelfs in landen waar auteurs hun economische rechten afstaan.',
    ],
    [
      'Wat betekent het als een merk "generiek" wordt?',
      [
        'De term is gewoon geworden voor het product, met risico op verlies van merkbescherming',
        'Het merk is in meerdere landen geregistreerd',
        'De merkhouder heeft derden het merk laten gebruiken in reclame',
        'Het merk is niet langer populair bij consumenten',
      ],
      0,
      'Dit gebeurt wanneer een merk de gewone naam voor het product zelf wordt (zoals "aspirine" of "roltrap" in de VS). Merkhouders voorkomen dit door het merk altijd met de soortnaam te gebruiken.',
    ],
    [
      'Wat is de primaire rol van de Wereldorganisatie voor de Intellectuele Eigendom (WIPO)?',
      [
        'Internationale IE-verdragen beheren en diensten verlenen voor octrooi-, merk- en modelregistratie en geschillenbeslechting',
        'Vervalsers direct vervolgen en wereldwijd handhavingsacties uitvoeren',
        'Uniforme IE-wetten vaststellen die alle landen onmiddellijk moeten toepassen',
        'Octrooien en merken rechtstreeks verlenen, ter vervanging van nationale bureaus',
      ],
      0,
      'WIPO, een gespecialiseerd VN-agentschap sinds 1974, beheert verdragen als het Verdrag van Parijs, de Berner Conventie, het PCT en het Madridprotocol. Zij voert handhaving niet uit—dat blijft een taak van de nationale rechtspraak.',
    ],
    [
      'Hoe verschilt auteursrechtbescherming van octrooibescherming naar reikwijdte?',
      [
        'Auteursrecht beschermt literaire en artistieke uitdrukking, octrooien beschermen uitvindingen en technische oplossingen',
        'Octrooien beschermen ideeën, auteursrecht beschermt alleen fysieke objecten',
        'Auteursrecht kan onbeperkt worden vernieuwd, octrooien worden slechts eenmaal verleend',
        'Octrooien beschermen morele rechten, auteursrecht beschermt alleen economische rechten',
      ],
      0,
      'Auteursrecht beschermt de oorspronkelijke uitdrukking van ideeën in literaire en kunstwerken (boeken, muziek, films, software). Octrooien beschermen uitvindingen en technische oplossingen. Zij dekken verschillende materie en verschillende wettelijke systemen.',
    ],
  ],
  msc: [
    [
      'Uit hoeveel boeken is het Nederlandse Burgerlijk Wetboek opgebouwd?',
      ['tien', 'zes', 'vier', 'acht'],
      0,
      'Het Burgerlijk Wetboek loopt van Boek 1 tot Boek 10 en verving van 1970 tot 1992 het oude wetboek uit 1838.',
    ],
    [
      'Wat is de beste omschrijving van de Hoge Raad der Nederlanden?',
      [
        'De hoogste rechter in civiele, strafrechtelijke en fiscale zaken, die toetst op rechtsvragen',
        'Het grondwettelijk hof dat door de Staten-Generaal aangenomen wetten ongrondwettig kan verklaren',
        'De hoogste bestuursrechter voor geschillen met de overheid',
        'Het gerecht dat ministers berecht voor ambtsmisdrijven',
      ],
      0,
      'De Hoge Raad beoordeelt geen feiten opnieuw; het is een cassatierechter die toetst of het recht juist is toegepast. In Nederland toetst de rechter wetten niet aan de Grondwet - artikel 120 van de Grondwet verbiedt dit uitdrukkelijk.',
    ],
    [
      'Wanneer wordt een merk vatbaar voor verval wegens "verwording tot soortnaam"?',
      [
        'Wanneer het door eigen nalatigheid van de merkhouder de gewone benaming van het product wordt in het algemeen taalgebruik',
        'Wanneer het door een licentienemer wordt gebruikt zonder schriftelijke licentieovereenkomst',
        'Wanneer het is geregistreerd in een klasse die niet overeenkomt met het feitelijke gebruik',
        'Wanneer het niet binnen vijf jaar na de oorspronkelijke aanvraagdatum wordt vernieuwd in het betreffende nationale merkenregister',
      ],
      0,
      '"Aspirine" en "escalator" verloren in de VS beide op deze manier hun merkbescherming. Houders verweren zich hiertegen door generiek gebruik te bestrijden en het merk altijd te combineren met de soortnaam van het product, zoals "Velcro-klittenband".',
    ],
    [
      'Wat mag een aangesloten land onder de Berner Conventie niet als voorwaarde stellen voor auteursrechtelijke bescherming?',
      [
        'Enige formaliteit, zoals registratie of een copyrightvermelding',
        'Publicatie in het land van herkomst',
        'Vertaling naar de taal van het land dat bescherming claimt',
        'Betaling van een aanvraagvergoeding aan een nationaal auteursrechtenbureau',
      ],
      0,
      'Het "geen formaliteiten"-beginsel van Berne (artikel 5(2)) is de reden dat auteursrecht bijna overal automatisch ontstaat bij het creëren van het werk. De VS trad pas in 1989 tot Berne toe en moest daarvoor de verplichte copyrightvermelding afschaffen.',
    ],
    [
      'Wat is de standaard minimumtermijn voor auteursrecht onder de Berner Conventie?',
      [
        'Het leven van de auteur plus 50 jaar',
        'Het leven van de auteur plus 70 jaar',
        '50 jaar na eerste publicatie, ongeacht het auteurschap',
        '25 jaar na het ontstaan van het werk',
      ],
      0,
      'Berne stelt de ondergrens op leven-plus-50; de EU verhoogde haar eigen termijn in 1993 naar leven-plus-70, en de VS volgde dat in 1998 met de Sonny Bono Act. Veel landen houden nog altijd het Berne-minimum aan.',
    ],
    [
      'Wat voor recht verleent het Europees Octrooibureau?',
      [
        'Een bundel nationale octrooien in de aangewezen staten, geen enkel EU-breed octrooi',
        'Een enkel octrooi dat in elke EU-lidstaat op identieke wijze afdwingbaar is',
        'Een octrooi dat alleen geldt in Duitsland, Frankrijk en het VK, zonder mogelijkheid tot uitbreiding naar enige andere verdragsstaat',
        'Een voorlopig recht dat door elk land afzonderlijk door het eigen octrooibureau moet worden bevestigd',
      ],
      0,
      'Een "Europees octrooi" door het EOB is een bundel nationale octrooien: het moet in elk land worden gevalideerd en kan daar afzonderlijk worden herroepen of gelicentieerd. Het eenheidsoctrooi werd in 2023 operationeel.',
    ],
    [
      'Om patenteerbaar te zijn in de meeste rechtssystemen moet een uitvinding nieuw, niet-voor-de-hand-liggend (inventief) zijn en wat nog meer?',
      ['Vatbaar voor toepassing op het gebied van de nijverheid', 'Aangevraagd door een rechtspersoon', 'Een jaar geheim gehouden voor de aanvraag', 'Herleid tot een fysiek prototype'],
      0,
      'Nieuwheid, inventiviteit en industriële toepasbaarheid zijn de drie pijlers van het EOV (artikel 52). "Reduction to practice" is een specifiek Amerikaans historisch begrip uit het oude first-to-invent-systeem, geen algemene vereiste.',
    ],
    [
      'Waar staat het Nederlandse woord "auteursrecht" het meest direct voor?',
      ['Het recht van de auteur', 'Uitgeeflicentie', 'Bedrijfsgeheim', 'Modelrecht'],
      0,
      'Continentaal-Europese systemen benaderen auteursrecht als "recht van auteur", gericht op persoonlijke en morele band, in tegenstelling tot Angelsaksische "copyright" die economisch recht op kopiëring benadrukt.',
    ],
    [
      'Wat maakt het Benelux-merken- en modellensysteem ongewoon?',
      [
        'Het registreert één merk dat geldig is in België, Nederland en Luxemburg als één gebied',
        'Het vereist afzonderlijke aanvragen in elk van de drie landen',
        'Het dekt alleen merken, geen modellen, omdat modelbescherming uitsluitend door het nationale bureau van elk land wordt afgehandeld',
        'Het verleent bescherming automatisch, zonder enige registratie',
      ],
      0,
      'Het Benelux-Bureau voor de Intellectuele Eigendom (BOIP) bestond al vóór het EU-merkensysteem en voert nog steeds een echt uniforme registratie voor de drie landen, een van de oudste supranationale IE-regimes in de wereld.',
    ],
    [
      'Hoe functioneert WIPO, de Wereldorganisatie voor de Intellectuele Eigendom?',
      [
        'Als gespecialiseerd agentschap van de Verenigde Naties dat IE-verdragen beheert',
        'Als onderdeel van de Wereldhandelsorganisatie, specifiek belast met het handhaven van handelsgerelateerde sancties',
        'Als EU-instelling met gezag alleen over de lidstaten',
        'Als particuliere branchevereniging zonder rol bij het opstellen van verdragen',
      ],
      0,
      'WIPO werd in 1974 een gespecialiseerd VN-agentschap en beheert verdragen zoals het Verdrag van Parijs, de Berner Conventie, het PCT en het Protocol van Madrid, maar heeft geen eigen handhavingsbevoegdheid - die ligt bij de nationale rechter en, voor handelsgerelateerde geschillen, bij de WTO.',
    ],
    [
      'Wat maakt het "prioriteitsrecht" van het Verdrag van Parijs mogelijk voor een aanvrager die in een aangesloten land een octrooi of merk aanvraagt?',
      [
        'Binnen een gestelde termijn in andere aangesloten landen aanvragen met behoud van de oorspronkelijke aanvraagdatum',
        'Automatisch bescherming krijgen in elk ander aangesloten land',
        'De beschermingstermijn in het land van eerste aanvraag verlengen met een periode gelijk aan de prioriteitstermijn zelf',
        'De aanvraag zonder formele overdracht overdragen aan een andere aanvrager',
      ],
      0,
      'De prioriteitstermijn is 12 maanden voor octrooien en 6 maanden voor merken en modellen. Deze bestaat juist omdat gelijktijdig wereldwijd aanvragen nooit realistisch was, zodat het Verdrag een latere buitenlandse aanvraag laat gelden als was die op de eerste aanvraagdatum ingediend.',
    ],
    [
      'De economische rechten in een auteursrechtelijk beschermd werk (bijv. reproductie, distributie) verschillen van morele rechten vooral omdat morele rechten wat doen?',
      [
        'De persoonlijke band van de auteur met het werk beschermen (naamsvermelding, integriteit) en doorgaans niet overdraagbaar zijn',
        'Vrij gekocht en verkocht kunnen worden als elk ander eigendom',
        'Alleen bestaan in common-law-rechtsstelsels, waar ze voor het eerst werden vastgelegd in wetten uit het begin van de twintigste eeuw over kunstwerken en literaire werken',
        'Onmiddellijk vervallen bij de eerste publicatie van het werk',
      ],
      0,
      'Morele rechten - het recht op naamsvermelding en het recht tegen aantasting of verminking van het werk - worden in de meeste civielrechtelijke stelsels, waaronder het Nederlandse, als onvervreemdbaar behandeld, ook nadat de economische rechten zijn overgedragen of verkocht.',
    ],
    [
      'Wat doet een aanvullend beschermingscertificaat (ABC) onder EU-recht voor een geoctrooieerd geneesmiddel of gewasbeschermingsmiddel?',
      [
        'Het verlengt de exclusiviteit na de twintigjarige octrooitermijn, met maximaal vijf jaar, ter compensatie van tijd verloren aan de regelgevende marktvergunningsprocedure',
        'Het verleent een geheel nieuwe octrooitermijn van twintig jaar die pas ingaat zodra de termijn van het oorspronkelijke octrooi volledig is verstreken',
        'Het zet het octrooi om in een merkregistratie voor hetzelfde product voor onbepaalde tijd',
        'Het verdubbelt automatisch het licentietarief dat een generieke fabrikant voor de rest van de octrooitermijn moet betalen',
      ],
      0,
      'ABC\'s verlengen de octrooitermijn met maximaal vijf jaar na de twintig jaar voor pharma en landbouwchemicaliën, ter compensatie voor regelgeving. EU-Verordeningen 469/2009 en 1610/96 bepalen de berekening en zijn gericht op pariteit met Amerikaans termijnherstel.',
    ],
    [
      'Wat bereikt een aanvraag onder het Patent Cooperation Treaty (PCT) precies?',
      [
        'Het regelt één internationale aanvraag die de prioriteitsdatum behoudt en toetreding tot de nationale of regionale fase uitstelt, zonder zelf een octrooi te verlenen',
        'Het verleent één uniform octrooi dat automatisch op identieke wijze afdwingbaar is in elk van de bij het PCT aangesloten staten',
        'Het leidt automatisch tot verlening van een Europees octrooi zonder enig onderzoek door het EOB',
        'Het levert een octrooitermijnverlenging op die identiek is in effect aan een aanvullend beschermingscertificaat',
      ],
      0,
      'Het PCT laat aanvragers één internationale aanvraag indienen met prioriteitsdatum en onderzoeksrapport, gevolgd door een nationale fase (~30 maanden) waarin elk bureau zelf over verlening beslist. Dit centraliseert de vroege kosten, terwijl de keuze van landen wordt uitgesteld.',
    ],
    [
      'Onder de EU-richtlijn bedrijfsgeheimen (2016/943) komt informatie alleen in aanmerking voor bescherming als bedrijfsgeheim wanneer aan welke combinatie van voorwaarden is voldaan?',
      [
        'Geheimhouding, commerciële waarde die aan die geheimhouding wordt ontleend, en redelijke maatregelen van de houder om ze geheim te houden',
        'De informatie is formeel geregistreerd bij een nationaal of EU-bureau voor intellectuele eigendom',
        'De informatie is alleen bekendgemaakt onder een formeel ondertekende, notarieel bekrachtigde geheimhoudings- en vertrouwelijkheidsovereenkomst die specifiek tussen de twee betrokken commerciële partijen is onderhandeld',
        'De informatie heeft ononderbroken minstens vijf volledige jaren geheim bestaan voordat een vordering wordt ingesteld',
      ],
      0,
      'Bescherming van bedrijfsgeheimen wordt bepaald door drie voorwaarden uit Richtlijn 2016/943: geheimhouding, commerciële waarde door die geheimhouding, en genomen redelijke maatregelen. Dit harmoniseerde nationale leerstukken en gaf houders een uniform civielrechtelijk rechtsmiddel.',
    ],
  ],
  phd: [
    [
      'Welke factoren weegt de "verwarringsgevaar"-toets in het EU-merkenrecht onder de EUTMV samen?',
      [
        'De gelijkenis van de tekens, de gelijkenis van de waren/diensten, en het onderscheidend vermogen van het oudere merk, globaal beoordeeld',
        'Alleen of de twee merken visueel identiek zijn',
        'Alleen de reputatie van het later aangevraagde merk, ongeacht enige gelijkenis tussen de waren of diensten onder elk teken of het onderscheidend vermogen van het oudere merk zelf',
        'Alleen of de waren in dezelfde fysieke winkels worden verkocht',
      ],
      0,
      'De "globale beoordeling" van het HvJEU behandelt factoren als onderling afhankelijk - zeer onderscheidend ouder merk kan verwarring veroorzaken zelfs bij ongelijkend later teken.',
    ],
    [
      'Waar gaat artikel 17 van de EU-richtlijn auteursrecht uit 2019 (voorheen het omstreden "artikel 13") primair over?',
      [
        'De aansprakelijkheid van online platforms voor het delen van content voor auteursrechtinbreukmakende uploads van gebruikers',
        'De harmonisatie van de auteursrechttermijn tussen lidstaten, een onderwerp dat juist wordt geregeld in de afzonderlijke Termijnrichtlijn van 1993',
        'Het recht van academische auteurs om het auteursrecht op wetenschappelijke artikelen te behouden',
        'De omvang van de uitzondering voor privékopiëren van fysieke media',
      ],
      0,
      'Artikel 17 maakt platforms direct aansprakelijk voor niet-toegestane uploads, tenzij zij licenties hebben of "beste inspanningen" leveren - verschuiving van eerdere "veilige haven"-model onder de Richtlijn elektronische handel.',
    ],
    [
      'Waarover heeft het Uniform Octrooigerecht (UPC), dat in 2023 van start ging, rechtsmacht?',
      [
        'Inbreuk en geldigheid van Europese octrooien en eenheidsoctrooien in de deelnemende lidstaten',
        'Alleen eenheidsoctrooien, niet klassieke Europese octrooien',
        'Alleen octrooigeschillen over geneesmiddelen',
        'Merkgeschillen binnen de EU, een aangelegenheid die juist uitsluitend is voorbehouden aan het EUIPO en nationale merkenrechters',
      ],
      0,
      'Het UPC geeft één rechtssysteem rechtsmacht over eenheidsoctrooi en klassieke Europese octrooien, waardoor inbreuk niet in elk land afzonderlijk moet worden bepleist.',
    ],
    [
      'In Windsurfing Chiemsee/Huber (1999) behandelde het HvJEU de vraag of een geografische naam als merk kan functioneren, en oordeelde het wat?',
      [
        'Een geografische naam kan worden geregistreerd als zij door gebruik onderscheidend vermogen heeft verkregen, ook al zijn zuiver beschrijvende geografische termen normaal uitgesloten',
        'Geografische namen kunnen onder geen enkele omstandigheid als merk worden geregistreerd',
        'Geografische namen zijn automatisch registreerbaar wanneer de betreffende waren niet daadwerkelijk op die plaats worden geproduceerd',
        'Geografische aanduidingen beschermd onder afzonderlijke EU-kwaliteitsregelingen voor landbouwproducten en gewone merken worden als volledig identieke juridische begrippen behandeld die dezelfde registratieroute vereisen',
      ],
      0,
      '"Chiemsee" (Beiers meer) stelde dat geografische termen van registratie zijn uitgesloten, tenzij merk onderscheidend vermogen door gebruik heeft verkregen - publiek associeert dan naam met handelsoorsprong, niet plaats. Dit voorkomt monopolisering van plaatsnamen voor concurrenten.',
    ],
    [
      'In Brüstle/Greenpeace (2011) legde het HvJEU de uitsluiting van octrooien op toepassingen van menselijke embryo\'s uit de Biotechnologierichtlijn op welke manier uit?',
      [
        'De uitsluiting geldt voor elke menselijke eicel vanaf het moment van bevruchting die in staat is menselijke ontwikkeling in gang te zetten, inclusief het gebruik van stamcellen verkregen door vernietiging van een embryo',
        'De uitsluiting geldt alleen voor embryo\'s ouder dan veertien dagen',
        'De uitsluiting geldt alleen voor gekloonde embryo\'s ontstaan door celkerntransplantatie, niet voor natuurlijk bevruchte embryo\'s',
        'De richtlijn beperkt octrooien op biotechnologische uitvindingen met embryonaal materiaal op geen enkele manier',
      ],
      0,
      'Brüstle hield octrooi op neurale precursorcellen van menselijke embryonale stamcellen. Greenpeace betwistte dit onder Richtlijn 98/44/EG-uitsluiting; het HvJEU gaf dit autonome, ruime betekenis en sloot octrooien uit op uitvindingen die embryovernietiging vereisen.',
    ],
    [
      'Wat betekent het leerstuk van "uitputting van rechten" in het EU-merken- en auteursrecht?',
      [
        'Zodra goederen met toestemming van de rechthebbende voor het eerst in de EER op de markt zijn gebracht, kan de rechthebbende verdere doorverkoop binnen de EER niet tegenhouden',
        'Een merkrecht vervalt permanent na tien jaar',
        'Auteursrecht kan niet worden uitgeput, alleen merken, omdat auteursrecht in de meeste civielrechtelijke stelsels wordt behandeld als een persoonlijk recht dat permanent aan de auteur verbonden blijft, ongeacht enige verkoop',
        'Een rechthebbende kan parallelimport van waar dan ook tegenhouden zodra de goederen de fabriek hebben verlaten',
      ],
      0,
      'Dit is juridische basis voor interne markt van originele goederen: de EU past regionale (niet internationale) uitputting toe, zodat rechthebbende parallelimport van buiten de EER kan tegenhouden.',
    ],
    [
      'In Google France/Louis Vuitton (2010) oordeelde het HvJEU dat een zoekmachine die het merk van een concurrent als betaald zoekwoord verkoopt wat doet?',
      [
        'Maakt zelf geen inbreuk op het merk, maar de adverteerder die het zoekwoord koopt kan inbreuk maken als de resulterende advertentie de herkomst- of reclamefunctie van het merk schaadt',
        'Maakt altijd inbreuk op het merk, ongeacht hoe duidelijk de resulterende gesponsorde advertentie de eigen goederen van de adverteerder onderscheidt van die van de merkhouder, en ongeacht enige daadwerkelijke verwarring',
        'Maakt nooit inbreuk, onder welke omstandigheden dan ook, omdat het kopen van een zoekwoord geen "gebruik" is door wie dan ook in het economisch verkeer',
        'Maakt alleen inbreuk als de zoekmachine zelf, in plaats van de adverteerder, rechtstreeks profijt trekt van die specifieke zoekwoordverkoop',
      ],
      0,
      'Google als zoekmachine maakte zelf geen inbreuk, maar gesponsorde advertenties schaden herkomstfunctie als consument niet kan zien of goederen van merkhouder of concurrent zijn. Dit trekt grens tussen neutrale tussenkomst en verwarrend gebruik.',
    ],
    [
      'Waarom was TRIPS (de WTO-overeenkomst inzake de handelsaspecten van de intellectuele eigendom) van belang?',
      [
        'Het verplichtte WTO-leden tot minimale IE-normen die via de WTO-geschillenbeslechting afdwingbaar zijn',
        'Het schafte octrooien op geneesmiddelen in ontwikkelingslanden af',
        'Het verving de Berner en de Parijse Conventie volledig',
        'Het creëerde WIPO als nieuwe internationale organisatie, terwijl WIPO in werkelijkheid al twee decennia eerder bestond als een gespecialiseerd VN-agentschap',
      ],
      0,
      'TRIPS (1994) was de eerste IE-overeenkomst met een bindend handhavingsmechanisme dat kruislingse retaliatie mogelijk maakt - een WTO-lid dat in overtreding wordt bevonden kan handelssancties krijgen in geheel andere sectoren, wat veel sterker is dan wat de WIPO-verdragen alleen boden.',
    ],
    [
      'L\'Oréal/Bellure (2009) breidde de merkbescherming voor merken met reputatie uit tot wat, verder dan de traditionele verwarringstoets?',
      [
        'Het onrechtmatig voordeel trekken uit de reputatie van het merk door meeliften, ook zonder verwarringsgevaar en zonder schade aan het onderscheidend vermogen van het merk',
        'Alleen gevallen waarin het nagemaakte product een verpakkingsontwerp gebruikte dat identiek was, in plaats van slechts vergelijkbaar, met het origineel',
        'Alleen nepgoederen die een merk dragen dat identiek is in plaats van slechts vergelijkbaar',
        'Alleen situaties waarin bewezen wordt dat de totale omzet van de gedaagde in die specifieke productmarkt, over de betreffende inbreukperiode, de vergelijkbare omzet van de merkhouder zelf overtrof',
      ],
      0,
      'Bellure verkocht "geursimulatie"-parfums met L\'Oréals geurennamen, zonder verwarring. Het HvJEU oordeelde dat bescherming tegen "onrechtmatig voordeel"-meeliften geen verwarring vereist - simpelweg meeliften voor verkoop volstaat.',
    ],
    [
      'Waarover ging het arrest van het HvJEU in Levola Hengelo/Smilde Foods (2018)?',
      [
        'Of de smaak van een voedingsproduct auteursrechtelijk beschermd kan worden',
        'Of het recept van een Nederlandse kaasspread als literair werk beschermd kan worden',
        'Of het merk "Heks\'nkaas" zelf beschermd kan worden',
        'Of het verpakkingsontwerp van een smeerkaas beschermd kan worden',
      ],
      0,
      'Het HvJEU oordeelde dat smaak niet auteursrechtelijk beschermd kan worden omdat deze niet met voldoende precisie en objectiviteit kan worden vastgesteld om aan het "werk"-vereiste onder het EU-auteursrecht te voldoen.',
    ],
    [
      'Wat maakt het Protocol van Madrid mogelijk voor een merkhouder?',
      [
        'Eén internationale aanvraag indienen die meerdere aangesloten landen aanwijst via één door WIPO beheerde procedure',
        'Een enkel merk verkrijgen dat automatisch wereldwijd geldig is',
        'Nationaal onderzoek in elk aangewezen land volledig overslaan',
        'Een merk registreren dat generiek is in het land van herkomst, iets wat geen internationaal of nationaal merkensysteem toestaat, welke aanvraagroute ook wordt gevolgd',
      ],
      0,
      'Madrid centraliseert aanvraag en vernieuwing administratief, maar het bureau van elk aangewezen land onderzoekt het merk nog steeds naar zijn eigen materiële recht en kan het weigeren - het is een aanvraaggemak, geen enkel eenheidsrecht, wat vaak tot verwarring leidt.',
    ],
    [
      'De leer van "first sale" in het Amerikaanse auteursrecht en "uitputting" in het EU-recht beperken allebei welk recht?',
      [
        'Het distributierecht, zodra een specifiek exemplaar rechtmatig is verkocht',
        'Het reproductierecht voor digitale exemplaren',
        'Het morele recht op naamsvermelding, dat in de meeste rechtsstelsels door geen enkele verkoop van een fysiek of digitaal exemplaar kan worden uitgeput',
        'Het recht om het werk in het openbaar uit te voeren',
      ],
      0,
      'Beide leerstukken laten eigenaar van rechtmatig verkregen exemplaar het doorverkopen of uitlenen zonder verder toestemming, omdat distributierecht uitgeput is door eerste toegestane verkoop.',
    ],
    [
      'In Stichting Brein/Ziggo en XS4ALL (2017) oordeelde het HvJEU dat het exploiteren van een online indexeringsplatform als The Pirate Bay wat inhoudt?',
      [
        'Een "mededeling aan het publiek" onder de InfoSoc-richtlijn, waarmee de exploitanten van het platform zelf aansprakelijk zijn, niet alleen de individuele uploaders',
        'Louter passief hosten dat beschermd wordt door de veilige haven van de Richtlijn elektronische handel, zonder enige aansprakelijkheid',
        'Rechtmatig handelen, omdat het indexeringsplatform zelf geen van de daadwerkelijke auteursrechtelijk beschermde bestanden opslaat, alleen hyperlinks, magnet-links en bijbehorende beschrijvende metadata',
        'Merkinbreuk in plaats van een auteursrechtelijke aangelegenheid, omdat het indexeren van content in essentie een merkfunctie is',
      ],
      0,
      'Het indexeren en categoriseren van torrentbestanden met volledige kennis van inbreuk maakt exploitanten tot "mededelers aan het publiek", niet tot neutrale tussenpersonen, ook al stonden de bestanden op gebruikerscomputers.',
    ],
    [
      'Wat staat de EU-"SPC-fabricagevrijstelling" uit 2019 (Verordening 2019/933) toe, als uitzondering op de exclusiviteit van het aanvullend beschermingscertificaat?',
      [
        'In de EU gevestigde fabrikanten van generieke en biosimilaire producten mogen het beschermde product tijdens de ABC-termijn produceren, uitsluitend voor export naar niet-EU-markten of voor voorraadopbouw binnen de EU vóór het verstrijken van het certificaat',
        'Elke fabrikant wereldwijd mag het ABC-beschermde product vrij binnen de EU verkopen tijdens de looptijd van het certificaat',
        'ABC-houders moeten hun product op FRAND-achtige voorwaarden licentiëren aan minstens één generieke of biosimilaire concurrent zodra het certificaat door het bevoegde nationale octrooibureau formeel wordt verleend',
        'De ABC-termijn wordt met twee jaar verkort voor elk vrijstellingsverzoek dat een aanvrager met succes indient',
      ],
      0,
      'EU-fabrikanten mogen gedurende het ABC-termijn produceren uitsluitend voor export of voorraadbouw, niet voor EU-verkoop - dit compenseert hun concurrentienadeel en stelt hen in staat generieke versies te lanceren wanneer het certificaat verstrijkt.',
    ],
    [
      'Waartegen biedt een niet-ingeschreven Gemeenschapsmodel onder het EU-modellenrecht de houder specifiek bescherming?',
      [
        'Alleen tegen opzettelijk kopiëren, niet tegen onafhankelijke totstandkoming van een gelijkend ontwerp',
        'Tegen elk identiek of gelijkend ontwerp, ongeacht hoe het is ontstaan',
        'Tegen niets - niet-ingeschreven modellen krijgen geen bescherming op EU-niveau',
        'Alleen tegen modellen die zijn ingeschreven in dezelfde lidstaat als de houder, een aanpak die het EU-regime helemaal niet volgt',
      ],
      0,
      'Belangrijkste verschil met ingeschreven model: niet-ingeschreven recht (drie jaar) vereist bewijs dat inbreukmaker daadwerkelijk heeft gekopieerd.',
    ],
  ],
  professor: [
    [
      'In Sabam/Netlog (2012) en Scarlet Extended/SABAM (2011) oordeelde het HvJEU dat het verplichten van een internetprovider tot het installeren van een algemeen filtersysteem tegen auteursrechtinbreuk in strijd zou zijn met wat?',
      [
        'Het verbod op het opleggen van een algemene toezichtsverplichting onder de Richtlijn elektronische handel, afgewogen tegen grondrechten',
        'De minimumtermijnvereiste van de Berner Conventie',
        'Het beginsel van nationale behandeling van het Verdrag van Parijs',
        'Het Verdrag van Rome inzake naburige rechten van uitvoerende kunstenaars, een instrument dat een geheel andere categorie naburige rechten regelt die niets met filterverplichtingen te maken heeft',
      ],
      0,
      'Het Hof oordeelde dat filterverplichtingen artikel 15 van de Richtlijn elektronische handel zouden schenden en vrijheid van ondernemerschap, gegevensbescherming en vrije meningsuiting onevenredig belasten.',
    ],
    [
      'Waarin was het Benelux-Gerechtshof, opgericht in 1974, historisch van betekenis?',
      [
        'Een van de vroegste internationale gerechten met de bevoegdheid prejudiciële beslissingen te geven over gemeenschappelijke Benelux-wetgeving, waaronder uniform merken- en modellenrecht',
        'De hoogste beroepsinstantie voor alle Nederlandse strafzaken, een functie die in werkelijkheid altijd uitsluitend bij de Hoge Raad der Nederlanden heeft berust',
        'Het eerste gerecht dat de leer van rechtstreekse werking van het HvJEU toepaste',
        'Het gerecht dat het grensgeschil tussen Nederland en België over Baarle-Nassau beslechtte',
      ],
      0,
      'Het ging vooraf aan het HvJEU-prejudiciële mechanisme en diende als model, was decennialang gezaghebbende uitlegger van Uniforme Benelux-wet inzake merken en modellen, voordat EU-unificatie zijn IE-rechtspraak grotendeels verving.',
    ],
    [
      'Wat oordeelde Svensson/Retriever Sverige (2014) over hyperlinken naar een werk dat al vrij online beschikbaar is met toestemming van de rechthebbende?',
      [
        'Dit vereist geen afzonderlijke toestemming van de rechthebbende, omdat er geen mededeling wordt gedaan aan een "nieuw publiek" naast degenen die de oorspronkelijke plaatsing al bereikte',
        'Het maakt altijd inbreuk op het auteursrecht, ongeacht de beschikbaarheid van de doelinhoud of hoe de oorspronkelijke rechthebbende deze eerst publiceerde',
        'Het maakt alleen inbreuk wanneer de link gebruikmaakt van framing-technieken in plaats van een gewone klikbare hyperlink',
        'Het vereist alleen afzonderlijke toestemming zodra de website die linkt zelf een abonnementskosten begint te vragen aan bezoekers voor toegang tot haar eigen pagina\'s',
      ],
      0,
      'Journalisten daagden nieuwsaggregatiesite aan voor linken naar vrij toegankelijke artikelen. Het HvJEU oordeelde dat omdat werken al voor alle gebruikers toegankelijk waren, hyperlinks geen "nieuw publiek" bereiken waarvoor afzonderlijke toestemming nodig is.',
    ],
    [
      'In het arrest Football Dataco/Yahoo! (2012) van het HvJEU oordeelde het Hof dat auteursrechtelijke bescherming van een databank onder de Databankrichtlijn wat specifiek vereist, en wat uitsluit?',
      [
        'Originele selectie of rangschikking die de vrije creatieve keuzes van de auteur weerspiegelt, met uitsluiting van aanzienlijke arbeid en vakkundigheid bij het verzamelen van de gegevens',
        'Alleen dat er aanzienlijke financiële investering is gedaan om de gegevens samen te stellen',
        'Dat de databank bij een nationaal IE-bureau is geregistreerd voordat een procedure wordt gestart',
        'Dat de gegevens zelf origineel zijn, ongeacht de rangschikking, een vereiste dat de Databankrichtlijn in werkelijkheid niet stelt aan auteursrechtelijke bescherming',
      ],
      0,
      'Dit ontkoppelde auteursrecht van sui-generis databankrecht: "zweet van voorhoofd" kan geen auteursrecht vestigen, alleen echte creatieve selectie of rangschikking kan dat.',
    ],
    [
      'Op welk specifiek scenario ging de leer uit IHT Internationale Heiztechnik/Ideal-Standard (1994) over merkuitputting binnen concernherstructureringen in?',
      [
        'Of een merk dat aan een niet-verbonden entiteit in één lidstaat is overgedragen, nog kon worden ingezet om invoer van originele goederen met hetzelfde merk uit een andere lidstaat te blokkeren nadat de overdracht de economische band had doorgesneden',
        'Of een franchisenemer een merk mocht gebruiken na afloop van de franchiseovereenkomst',
        'Of een merk gelijktijdig door twee niet-verbonden bedrijven in verschillende EU-staten kon worden geregistreerd',
        'Of merkrechten het faillissement van de oorspronkelijke eigenaar overleven, een afzonderlijke insolventierechtelijke vraag die wordt beheerst door nationale faillissementswetten en de EU-Insolventieverordening, niet door de merkuitputtingsrechtspraak van het HvJEU die in deze verwijzing aan de orde was',
      ],
      0,
      'Het HvJEU oordeelde dat wanneer merkrechten in verschillende staten zonder economische band zijn, de verkrijger WEL invoer kan blokkeren - vrijwillige versnippering doorbreekt uitputting, in tegenstelling tot bedrijfsreorganisatie met eenheid van zeggenschap.',
    ],
    [
      'GS Media/Sanoma (2016) breidde de "nieuw publiek"-analyse voor hyperlinks uit tot content die zonder toestemming van de rechthebbende is geplaatst, en liet aansprakelijkheid vooral van wat afhangen?',
      [
        'Of de linker wist of had moeten weten dat de gelinkte content onrechtmatig was geplaatst, met een vermoeden van wetenschap wanneer de link wordt geplaatst met winstoogmerk',
        'Of de gelinkte content is gehost op een server die fysiek buiten de Europese Unie staat',
        'Of de link een verkorte URL gebruikt in plaats van het oorspronkelijke, onverkorte webadres',
        'Of de oorspronkelijke inbreukmaker die de onrechtmatige content het eerst plaatste, al is geïdentificeerd en elders met succes is aangeklaagd',
      ],
      0,
      'GeenStijl linkte naar uitgelekte Playboy-foto\'s zonder Sanoma\'s toestemming. Het HvJEU oordeelde dit niet-toegestane mededeling aan "nieuw publiek" kan zijn, maar aansprakelijkheid hangt af van of linker wist dat plaatsing onrechtmatig was.',
    ],
    [
      'Artikel 6bis van de Berner Conventie, over morele rechten, werd door de Verenigde Staten historisch vooral weerstaan wegens spanning met welk kenmerk van de Amerikaanse auteursrechtpraktijk van vóór 1976?',
      [
        'De "work made for hire"-leer, waaronder de werkgever, niet de individuele maker, als auteur wordt aangemerkt',
        'Het ontbreken van een auteursrechtregistratiesysteem',
        'De kortere Amerikaanse auteursrechttermijn ten opzichte van Europa',
        'De Amerikaanse praktijk om auteursrecht alleen aan eigen burgers te verlenen, een beperking die in werkelijkheid nooit heeft bestaan in het Amerikaanse auteursrecht',
      ],
      0,
      'Work-for-hire wijst auteurschap toe aan werkgever, ongemakkelijk tegenover morele rechten op persoonlijke banden. Daarom stelde VS bij Berne-toetreding 1989 dat bestaand recht al voldeed, in plaats van morele-rechtenwet in te voeren.',
    ],
    [
      'De "essentiële functie"-leer van het HvJEU, ontwikkeld vanaf Hoffmann-La Roche/Centrafarm (1978), omschrijft de kernfunctie van een merk als wat?',
      [
        'Het waarborgen van de herkomstidentiteit van de gemerkte waren of diensten voor de consument',
        'Het maximaliseren van het economisch rendement voor de rechthebbende',
        'Het voorkomen dat enige derde ooit een gelijkend teken gebruikt',
        'Het aanduiden van de geografische oorsprong van de goederen, een functie die in plaats daarvan wordt vervuld door geografische aanduidingen, niet door het gewone merkenrecht',
      ],
      0,
      'Deze "herkomstfunctie"-redenering bepaalt hoe ver merkhouders herverpakking, rebranding en parallelhandel mogen beheersen - bescherming reikt alleen zo ver als nodig om herkomstgarantie te bewaren.',
    ],
    [
      'Wat oordeelde Land Nordrhein-Westfalen/Renckhoff (2018) over een leerling die een vrij toegankelijke foto, eerder met toestemming van de auteur geplaatst, opnieuw uploadt naar een schoolwebsite?',
      [
        'Dit is een nieuwe mededeling aan het publiek die opnieuw toestemming vereist, omdat de foto op een andere, van de oorspronkelijke plaatsing onafhankelijke server werd geplaatst',
        'Er ontstaat helemaal geen nieuwe mededeling, omdat de foto al vrij en rechtmatig toegankelijk was gemaakt voor elke internetgebruiker, ruim voordat de leerling deze opnieuw uploadde',
        'Dit maakt alleen inbreuk op morele rechten, niet op de economische reproductie- of mededelingsrechten',
        'Dit is toegestaan onder de EU-citaatuitzondering, omdat de herupload een educatief doel diende',
      ],
      0,
      'Opnieuw uploaden naar onafhankelijke server haalt zeggenschap van rechthebbende uit handen - als origineel wordt verwijderd, blijft kopie bestaan en vereist eigen toestemming. Dit trekt grens tussen linken (veilig) en herhosten (toestemming nodig).',
    ],
    [
      'Wat beschermde de Nederlandse "geschriftenbescherming", een sui-generis regeling in het Nederlandse auteursrecht, vóór haar afschaffing in 2018?',
      [
        'Niet-originele geschriften (zoals dienstroosters of catalogi) die het "eigen, oorspronkelijke karakter" missen dat nodig is voor volledig auteursrecht',
        'Mondelinge folklore en ongeschreven tradities',
        'Specifiek broncode van computers',
        'Foto\'s zonder artistieke waarde, een categorie die in werkelijkheid nooit onder deze specifiek op geschriften gerichte sui-generis leer viel',
      ],
      0,
      'Deze Nederlandse sui-generis leer gaf bescherming aan feitelijke teksten die oorspronkelijkheidsnorm niet haalden. Zij werd geschrapt nadat HvJEU (Football Dataco, Infopaq) duidelijk maakte dat EU-auteursrecht echte oorspronkelijkheid vereist.',
    ],
    [
      'In Huawei/ZTE (2015) stelde het HvJEU een onderhandelingskader vast dat bepaalt wanneer het verzoek van een houder van een standaard-essentieel octrooi om een verbod wat doet?',
      [
        'Kan een misbruik van machtspositie onder artikel 102 VWEU opleveren, tenzij de SEO-houder eerst bepaalde te-goeder-trouw-licentiestappen doorloopt voordat hij een procedure start',
        'Is automatisch en in elk geval een misbruik van machtspositie, ongeacht het eerdere gedrag van beide partijen',
        'Kan nooit een misbruik van machtspositie onder artikel 102 VWEU opleveren, omdat octrooirechten als absoluut worden behandeld en volledig immuun zijn voor mededingingsrechtelijke toetsing onder vaste EU-rechtspraak',
        'Hangt uitsluitend af van de vraag of de gebruiker al een geheimhoudingsovereenkomst met de octrooihouder heeft ondertekend',
      ],
      0,
      'Huawei bezat octrooien essentieel voor een telecommunicatiestandaard met FRAND-licentieverplichting; het Hof oordeelde dat verbodsvorderingen artikel 102 kunnen schenden, tenzij SEO-houder eerst waarschuwt en specifiek FRAND-aanbod doet. Dit weegt eigendomsrechten tegen "hold-up"-risico.',
    ],
    [
      'Aan welke twee voorwaarden moet een "parodie" volgens het arrest van het HvJEU in Deckmyn/Vandersteen (2014) over de parodie-uitzondering onder de InfoSoc-richtlijn voldoen, zonder andere vaak veronderstelde voorwaarden te moeten vervullen?',
      [
        'Het oorspronkelijke werk oproepen terwijl het merkbaar afwijkt daarvan, en een uiting van humor of spot vormen, zonder dat eigen oorspronkelijkheid of expliciete vermelding van komische bedoeling nodig is',
        'Geregistreerd zijn als parodie bij een nationale auteursrechtinstantie en voorafgaande toestemming van de oorspronkelijke auteur verkrijgen, formaliteiten die geen enkel EU-lidstaats auteursrecht in werkelijkheid vereist voor de uitzondering',
        'Niet-commercieel zijn en alleen voor privé, persoonlijk gebruik worden ingezet',
        'Korter zijn dan het oorspronkelijke werk en niet meer dan tien procent daarvan gebruiken',
      ],
      0,
      'Het Hof oordeelde dat parodie werking van oorspronkelijk werk oproepen en humor/spot vereist. Rechters moeten belangen van auteur tegen vrijheid van meningsuiting afwegen. Parodieverweer kan falen als boodschap discriminerend is.',
    ],
    [
      'Behandelde Sky plc/SkyKick UK Ltd (2020) de vraag of het registreren van een merk voor een uitzonderlijk brede specificatie, zoals eenvoudigweg "computersoftware", wat kan opleveren?',
      [
        'Kwade trouw, althans deels, als er geen werkelijke intentie was om het merk over de volle breedte van de opgeëiste waren of diensten te gebruiken',
        'Een automatische grond om de gehele registratie te herroepen, ongeacht enig daadwerkelijk gebruik dat wordt aangetoond voor engere waren daarbinnen',
        'Een strafbaar feit onder het EU-merkenrecht',
        'Een grond voor het betreffende nationale of EU-merkenbureau om registratie al vóór verlening uitdrukkelijk te weigeren, een materiële toetsing die het HvJEU verklaarde dat zulke bureaus in feite verplicht zijn uit te voeren in de onderzoeksfase',
      ],
      0,
      'SkyKick betoogde dat Sky\'s brede merken ongeldig waren wegens gebrek aan duidelijkheid of kwade trouw. Het HvJEU oordeelde dat te brede specificaties niet automatisch ongeldig zijn, maar kwade trouw kan registratie deels ongeldig maken.',
    ],
    [
      'De rechtspraaklijnen "Slovak Telekom" en het eerdere "Bronner" van het HvJEU over weigering van licentie of levering als misbruik van machtspositie onder artikel 102 VWEU zijn leerstellig van belang voor het IE-recht omdat zij bepalen wanneer wat moet wijken voor het mededingingsrecht?',
      [
        'Het recht van een IE-houder om een licentie te weigeren, in beperkte gevallen waarin weigering concurrentie op een verwante markt uitsluit en de input werkelijk onmisbaar is',
        'Alle octrooien vervallen automatisch zodra de houder in enige markt een machtspositie heeft',
        'Merkhouders moeten in elke EU-lidstaat op verzoek licentiëren aan concurrenten',
        'Auteursrecht kan onder geen enkele omstandigheid worden afgedwongen tegen een onderneming met machtspositie, een algemene regel die geen enkele EU-mededingings- of auteursrechtelijke instantie in enige gepubliceerde beslissing ooit heeft aangenomen',
      ],
      0,
      'Bronner (1998) stelde strenge onmisbaarheid-plus-uitsluitingstoets vast die verplichte licentiëring onder mededingingsrecht uitzonderlijk maakt. Deze spanning blijft leerstellig betwist kruispunt.',
    ],
    [
      'Welke vraag van rechtsmacht onder de EU-Merkenverordening behandelde AMS Neve/Heritage Audio (2019)?',
      [
        'Of een rechter in de lidstaat waar consumenten worden aangetrokken door online reclame en verkoopaanbiedingen rechtsmacht heeft over een vordering wegens inbreuk op een EU-merk, ook als de gedaagde elders gevestigd is',
        'Of een EU-merk überhaupt buiten de enkele lidstaat waarin het oorspronkelijk werd geregistreerd, kan worden afgedwongen',
        'Of rechtsmacht altijd uitsluitend bij de rechter van het land van vestiging of oprichting van de gedaagde ligt, ongeacht waar in de EU enige daadwerkelijke commerciële schade voor de merkhouder feitelijk is ontstaan',
        'Of merkgeschillen via arbitrage moeten worden beslecht in plaats van via een procedure zodra een EU-merk is verleend',
      ],
      0,
      'AMS Neve klaagde Heritage Audio aan in het VK wegens online advertenties gericht op consumenten. Het HvJEU oordeelde dat "lidstaat waar inbreuk plaatsvindt" ook de staat omvat waar online content consumenten aantrekt.',
    ],
  ],
};
